<div class="row mh-30-vh">
    <div class="col mb-3 text-center">
        <img class="img-fluid mh-30-vh" src="../../../assets/img/azul-amarillo.svg" alt="LoCana">
    </div>
</div>
<h1 class="text-center mt-2 mb-4">¿Podemos ayudarte?</h1>
<div class="container-fluid w-70">
    <app-contact-form [email]="user.email" [regReport]="regReport"></app-contact-form>
</div>